<ng-container *ifScreenSize="screenSize.Desktop">
  <fgb-banner>
    <ng-template>
      <div class="text-start" *ngIf="memberDetails$ | async as memberDetails">
        <div class="welcome-text d-flex align-items-center gap-1">
          <h2 class="mb-1 mt-0">
            {{ ('home.page.welcome' | translate) + ' ' + (memberDetails.FirstName + ' ' + memberDetails.Surname) + '!' }}
          </h2>
          <span class="material-icons icons" [routerLink]="['/account']">chevron_right</span>
        </div>
        <p class="m-0 font-size-14">{{ ('member.card.id' | translate) + ' : ' + memberDetails.ExternalRefNumber }}</p>
      </div>
    </ng-template>
  </fgb-banner>
</ng-container>
<fgb-mobile-nav-menu *ifScreenSize="screenSize.Mobile"></fgb-mobile-nav-menu>
<ng-container *ifScreenSize="screenSize.Mobile">
  <div class="tier-container pb-3 bg-primary">
    <div class="barcode-container">
      <fgb-barcode [borderRadius]="false" [showDiscounts]="false"></fgb-barcode>
    </div>
    <fgb-hub-button-nav />
  </div>
</ng-container>
<div class="mobile-content-wrapper">
  <ng-container *notInProductCode="productCode.NonRenewing">
    <!-- Dynamic Feed -->
    <fgbcl-loyalty-feed-list></fgbcl-loyalty-feed-list>
    <!--Voucher-->
    <div class="container">
      <fgb-vouchers></fgb-vouchers>
    </div>

    <!--Scorecard carousel-->
    <fgbcl-scorecard-carousel [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>
  </ng-container>

  <ng-container *inProductCode="productCode.NonRenewing">
    <fgb-non-renewing />
  </ng-container>

  <div class="container">
    <!-- Featured Rewards -->
    <fgbcl-featured-rewards *notInProductCode="productCode.NonRenewing"></fgbcl-featured-rewards>

    <!-- Announcements -->
    <fgbcl-announcements></fgbcl-announcements>
  </div>
</div>
